import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import Home from './pages/Home';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import Blog from './pages/Blog';
import Dashboard from './pages/Dashboard';

const App: React.FC = () => {
  return (
    <Auth0Provider
      domain="dev-g7m8pmt4zn2m0kaw.us.auth0.com"
      clientId="CEyhN8ipFCqiPPY8dJ9HPblYe7U5mz6b"
      authorizationParams={{
        redirect_uri: window.location.origin
      }}
    >
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/dashboard" element={<Dashboard />} />
          {/* Add other routes as needed */}
        </Routes>
      </Router>
    </Auth0Provider>
  );
};

export default App;
